import "shared/extensions/string";

import { EventNames } from "core/monitoring/types/enums";
import { LocaleIdToWisdomAiLocaleMap } from "shared/core/locale";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import StylableButton from "shared/UI/Buttons/StylableButton";
import { ReactComponent as WisdomAILogo } from "shared/assets/Icons/wisdom-ai-full.svg";
import { externalLink } from "core/links";
import { t } from "i18next";
import { trackEvents } from "core/monitoring/Events";
import useLocale from "core/hooks/useLocale/useLocale";

export const WisdomAIButtonCard = () => {
  const { localeId } = useLocale();
  const handleClickWisdomAI = () => {
    trackEvents(EventNames.WISDOM_AI_CLICK);
    externalLink(`${process.env.REACT_APP_WISDOM_AI_URI!}${LocaleIdToWisdomAiLocaleMap[localeId]}`);
  };

  return (
    <RoundedCard className="flex flex-col gap-4">
      <WisdomAILogo width="170" height="40" />
      <p>{t("contactUs.wisdomAI.description")}</p>
      <StylableButton fullWidth text={t("contactUs.wisdomAI.button")} color="primary" onClick={handleClickWisdomAI} />
    </RoundedCard>
  );
};
